import { codeSplit } from "bernie-core";
import {
  FlexComponentMap,
  ImportReactComponent
} from "src/components/flexFramework/FlexComponents/typings";

export const moduleDefinitionsMap: FlexComponentMap = new Map()
  .set("region", {
    webpackChunkName: "flex-SimpleContainer",
    codeSplit: codeSplit(
      () =>
        import(/* webpackChunkName: "flex-SimpleContainer" */ "components/flexComponents/SimpleContainer/SimpleContainer") as ImportReactComponent
    )
  })
  .set("tab-group", {
    webpackChunckName: "flex-TabGroup",
    codeSplit: codeSplit(
      () =>
        import(/* webpackChunkName: "flex-TabGroup" */ "components/flexComponents/TabGroup/TabGroup") as ImportReactComponent
    )
  })
  .set("property-reviews", {
    webpackChunkName: "flex-PropertyReviewsWrapper",
    codeSplit: codeSplit(
      () =>
        import(/* webpackChunkName: "flex-PropertyReviewsWrapper" */ "components/flexComponents/PropertyReviewsWrapper/PropertyReviewsWrapper") as ImportReactComponent
    )
  })
  .set("property-reviews-summary", {
    webpackChunkName: "flex-PropertyReviewsSummaryWrapper",
    codeSplit: codeSplit(
      () =>
        import(/* webpackChunkName: "flex-PropertyReviewsSummaryWrapper" */ "components/flexComponents/PropertyReviewsSummaryWrapper/PropertyReviewsSummaryWrapper") as ImportReactComponent
    )
  })
  .set("property-reviews-headline", {
    webpackChunkName: "flex-PropertyReviewsHeadlineWrapper",
    codeSplit: codeSplit(
      () =>
        import(/* webpackChunkName: "flex-PropertyReviewsHeadlineWrapper" */ "components/flexComponents/PropertyReviewsHeadline/PropertyReviewsHeadlineWrapper") as ImportReactComponent
    )
  })
  .set("property-hero-image", {
    webpackChunkName: "flex-PropertyHeroImageWrapper",
    codeSplit: codeSplit(
      () =>
        import(/* webpackChunkName: "flex-PropertyHeroImageWrapper" */ "components/flexComponents/PropertyHeroImage/PropertyHeroImageWrapper") as ImportReactComponent
    )
  });
